import AccomplishmentCard from "views/Builder/components/accomplishments/cards";

import badgeImage from "../assets/product-design-guild-badge.png";
import backgroundImage from "../assets/product-design-guild-background.png";

export const ProductDesignGuildCard = () => (
  <AccomplishmentCard
    badgeImage={badgeImage}
    backgroundImage={backgroundImage}
    title="Product Design guild member"
    description="A creative force shaping intuitive, impactful product experiences."
  />
);
